import React, { PropsWithChildren } from 'react';
import { SummaryTermsSection } from './SummaryTermsSection';
import { CheckboxField } from '@qover/molecules';
import { ValidateResponse_Term } from '@qover-private/protos-web/qover/dojo/terms/v1/terms';
import messages from './summaryCheckboxAgreement.messages';
import { useBrokerLinks, useDocumentLink } from '@qover/hooks';

export type SummaryCheckboxAgreementProps = PropsWithChildren<{
  generalConditions?: string;
  ipid?: string;
  secondaryAgreement?: boolean;
  terms: ValidateResponse_Term;
}>;

export function SummaryCheckboxAgreement(props: SummaryCheckboxAgreementProps) {
  const { generalConditions = 'generalConditions', ipid = 'IPID' } = props;
  const getLink = useDocumentLink();
  const { privacyPolicy } = useBrokerLinks();

  const dataShareConsent = props.terms?.texts?.find(
    text => text.type === 'dataShareConsent',
  );

  return (
    <SummaryTermsSection>
      <CheckboxField
        id="form.clientAgreementWithLink"
        name="clientAgreement"
        data-test="clientAgreementWithLink"
      >
        {messages.termsAgreements(
          getLink(generalConditions),
          getLink(ipid),
          privacyPolicy,
        )}
      </CheckboxField>
      {dataShareConsent && (
        <CheckboxField
          id="terms.dataShareConsent"
          initialValue={false}
          data-test="terms.dataShareConsent"
          name="terms.dataShareConsent"
        >
          {dataShareConsent.value}
        </CheckboxField>
      )}
      {props.secondaryAgreement && (
        <>
          <h4 style={{ marginBottom: '20px' }}>
            {messages.termsAgreementsTitle2}
          </h4>
          <CheckboxField
            id="form.clientAgreement2"
            name="clientAgreement2"
            data-test="clientAgreement2"
          >
            {messages.termsAgreements2(
              getLink(generalConditions),
              getLink(ipid),
              privacyPolicy,
            )}
          </CheckboxField>
        </>
      )}
    </SummaryTermsSection>
  );
}
